import {createContext,useContext} from "react";



export const ConstanciaContext = createContext(undefined);
export function useConstancia(){
    return useContext(ConstanciaContext);
}
